import routes from "./onboarding";

const externalRoutes = routes.reduce(
  (acc, route) =>
    acc.set(route.name, {
      path: route.path,
      title: route.meta.pageTitle,
      authRequired: route.meta.authRequired
    }),
  new Map()
);

export default externalRoutes;
